import request from '@/utils/request_zcm'

export function getCodeId(params) {
  return request({
    method: 'get',
    withCredentials: true,
    url: 'loginInfo',
    params
  })
}
export function getOut(params) {
  return request({
    method: 'get',
    withCredentials: true,
    url: 'loginOut',
    params
  })
}


export function getLogin2DingTalk(params) {
  return request({
    method: 'get',
    url: '/loginInfoMd',
    params
  })
}

export function currentUserType() {
  return request({
    method: 'get',
    url: 'authorization/currentUserType'
  })
}
//限制修改
export function kingdeeDataUser() {
  return request({
    method: 'get',
    url: 'authorization/kingdeeDataUser'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js